import { createSlice } from '@reduxjs/toolkit';

/**
 * @private
 */
const materialClassUiInitialState = {
  searchTerm: '',
};
/**
 * @public
 * @name materialClassUiSlice
 * @description Declares a slice for redux store state.
 */
export const materialClassUiSlice = createSlice({
  name: 'materialClasses',
  initialState: materialClassUiInitialState,
  reducers: {
    searchMaterialClassByName: (state, action) => ({
      ...state,
      searchTerm: action.payload,
    }),
    clearMaterialClassUiState: () => ({ ...materialClassUiInitialState }),
  },
});

/**
 * @public
 * @name materialUiActions
 * @description Provides actions for material.
 */
export const materialClassUiActions = materialClassUiSlice.actions;
